import React from "react";
import { Modal, Button } from "antd";
import dayjs from "dayjs";
import { Bar } from "@ant-design/plots";
import { arrayMoveElementsByIndex } from "../../../utils/utility";

const QRManagementStatisticsModal = ({
  openStatisticsModal,
  setOpenStatisticsModal,
  columnRecord,
}) => {
  const currentDay = dayjs();
  const oneMonthBack = currentDay.subtract(1, "month");

  const statisticsByDay = (type) => {
    const visits = columnRecord?.statistics?.[type]?.map(
      (item) => item.split(" ")[0]
    );
    const counts = {};
    visits?.forEach((x) => {
      counts[x] = (counts[x] || 0) + 1;
    });
    return Object.entries(counts)
      ?.map(([key, value]) => {
        const reversedDateKey = arrayMoveElementsByIndex(
          key.split(" ")[0].split("-"),
          0,
          1
        ).join("-");
        const parts = reversedDateKey.split("-");
        if (parts.length >= 3) {
          const formattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
          return { date: dayjs(formattedDate), count: value };
        }
        return { date: dayjs(reversedDateKey), count: value };
      })
      ?.filter((item) => item.date <= currentDay && item.date >= oneMonthBack)
      .sort((a, b) => (dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1))
      .map((item) => {
        return {
          date: dayjs(item.date).format("DD-MM-YYYY"),
          count: item.count,
        };
      });
  };

  const visitsStatisticsArray = statisticsByDay("visits")?.map((item) => {
    return {
      label: item.date,
      type: "Посещения",
      value: item.count,
    };
  });

  const ordersStatisticsArray = statisticsByDay("orders")?.map((item) => {
    return {
      label: item.date,
      type: "Поръчки",
      value: item.count,
    };
  });

  const paymentsStatisticsArray = statisticsByDay("myPosPayments")?.map(
    (item) => {
      return {
        label: item.date,
        type: "Плащания",
        value: item.count,
      };
    }
  );

  const data = [
    ...visitsStatisticsArray,
    ...ordersStatisticsArray,
    ...paymentsStatisticsArray,
  ];

  const chartConfig = {
    data: data,
    isStack: true,
    xField: "value",
    yField: "label",
    seriesField: "type",
    label: {
      position: "middle",
      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
    },
  };

  return (
    <Modal
      title={
        <p className="statistics-modal-title ">Маса {columnRecord.name}</p>
      }
      width={window.innerWidth > 760 ? "80%" : "90%"}
      bodyStyle={{ height: "700px" }}
      centered
      closable={false}
      footer={
        <div className="statistics-modal-footer">
          <Button type="primary" onClick={() => setOpenStatisticsModal(false)}>
            Затвори
          </Button>
        </div>
      }
      open={openStatisticsModal}
      onCancel={() => setOpenStatisticsModal(false)}
    >
      <Bar {...chartConfig} />
    </Modal>
  );
};

export default QRManagementStatisticsModal;
